// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"532":"styles","678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"532":"7743cc58d3b9caae8ff9","678":"3d55045f58613f998bbe","883":"c5f8b691729d55c46160"}[chunkId] + ".js";
};